import React, { useState, useEffect } from "react";
import PageHero from "../components/PageHero";
import { getProjects, getSettings } from "../api";
import { ArrowUpRight } from "lucide-react";

export default function Works() {
  const [projects, setProjects] = useState([]);
  const [settings, setSettings] = useState({});
  useEffect(() => { getProjects().then(setProjects); getSettings().then(setSettings); }, []);

  return (
    <main>
      <PageHero title="Projects" subtitle={settings.projects_hero_subtitle || "Selected work that defines our craftfrom high-rise residentials to landmark public infrastructure."} num="03"/>
      <section className="py-20 bg-white">
        <div className="max-w-[1500px] mx-auto px-5 md:px-8">
          <div className="space-y-2">
            {projects.map((w, i) => (
              <a key={w.id || i} href="#" className="group block border-b border-[#ececef] hover:border-[#ef2435] transition-colors">
                <div className="grid grid-cols-12 gap-4 items-center py-6 md:py-8">
                  <div className="col-span-1 font-mono text-sm text-[#ef2435] font-semibold">{String(i+1).padStart(2,'0')}</div>
                  <div className="col-span-11 md:col-span-3">
                    <p className="text-xs uppercase tracking-widest text-gray-500 font-mono mb-1">{w.client}</p>
                    <h3 className="font-display text-3xl md:text-4xl text-gray-900 group-hover:text-[#ef2435] transition-colors">{w.title}</h3>
                  </div>
                  <div className="hidden md:block md:col-span-4 aspect-[16/10] rounded-2xl overflow-hidden bg-[#fafafa]">
                    <img src={w.image || w.img} alt={w.title} className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-700"/>
                  </div>
                  <div className="hidden md:block md:col-span-3 text-gray-600 text-sm leading-relaxed line-clamp-3">{w.description || w.desc}</div>
                  <div className="col-span-12 md:col-span-1 flex md:justify-end">
                    <div className="w-12 h-12 rounded-full border border-[#ececef] flex items-center justify-center group-hover:bg-[#ef2435] group-hover:border-[#ef2435] transition-colors">
                      <ArrowUpRight className="text-gray-600 group-hover:text-white" size={18}/>
                    </div>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
